/**
 * MDX treats raw `<...>` in prose as JSX/HTML. LLM-generated plans often
 * include innocent placeholders like `<local time>` that break @mdxeditor/editor
 * rendering entirely. Escape angle brackets outside fenced / inline code blocks
 * so arbitrary markdown displays without requiring authors to avoid `<`.
 *
 * Plan-specific scrubbing (e.g. the `<!-- clarity: N -->` tag the planner
 * appends) lives on the backend — see ``src/utils/planning.py`` and the
 * ``PlanningSession.current_plan`` set-event listener. Keeping it write-side
 * means readers always get clean text.
 */
const CODE_SEGMENT = /(```[\s\S]*?```|`[^`\n]+`)/g;

export function sanitizeForMdx(markdown) {
    if (!markdown) return '';

    return markdown
        .split(CODE_SEGMENT)
        .map((segment) => {
            if (
                segment.startsWith('```') ||
                (segment.startsWith('`') &&
                    segment.endsWith('`') &&
                    segment.length > 1)
            ) {
                return segment;
            }
            return segment.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        })
        .join('');
}
